//конвертация относительных ссылок в абсолютные
function rel_to_abs(url){
    /* Only accept commonly trusted protocols:
     * Only data-image URLs are accepted, Exotic flavours (escaped slash,
     * html-entitied characters) are not supported to keep the function fast */
  if(/^(https?|file|ftps?|mailto|javascript|data:image\/[^;]{2,9};):/i.test(url))
         return url; //Url is already absolute

    var base_url = location.href.match(/^(.+)\/?(?:#.+)?$/)[0]+"/";
    if(url.substring(0,2) == "//")
        return location.protocol + url;
    else if(url.charAt(0) == "/")
        return location.protocol + "//" + location.host + url;
    else if(url.substring(0,2) == "./")
        url = "." + url;
    else if(/^\s*$/.test(url))
        return ""; //Empty = Return nothing
    else url = "../" + url;

    url = base_url + url;
    var i=0
    while(/\/\.\.\//.test(url = url.replace(/[^\/]+\/+\.\.\//g,"")));

    /* Escape certain characters to prevent XSS */
    url = url.replace(/\.$/,"").replace(/\/\./g,"").replace(/"/g,"%22")
            .replace(/'/g,"%27").replace(/</g,"%3C").replace(/>/g,"%3E");
    return url;
}
function replace_all_rel_by_abs(html){
    /*HTML/XML Attribute may not be prefixed by these characters (common 
       attribute chars.  This list is not complete, but will be sufficient
       for this function (see http://www.w3.org/TR/REC-xml/#NT-NameChar). */
    var att = "[^-a-z0-9:._]";

    var entityEnd = "(?:;|(?!\\d))";
    var ents = {" ":"(?:\\s|&nbsp;?|&#0*32"+entityEnd+"|&#x0*20"+entityEnd+")",
                "(":"(?:\\(|&#0*40"+entityEnd+"|&#x0*28"+entityEnd+")",
                ")":"(?:\\)|&#0*41"+entityEnd+"|&#x0*29"+entityEnd+")",
                ".":"(?:\\.|&#0*46"+entityEnd+"|&#x0*2e"+entityEnd+")"};
                /* Placeholders to filter obfuscations */
    var charMap = {};
    var s = ents[" "]+"*"; //Short-hand for common use
    var any = "(?:[^>\"']*(?:\"[^\"]*\"|'[^']*'))*?[^>]*";
    /* ^ Important: Must be pre- and postfixed by < and >.
     *   This RE should match anything within a tag!  */

    /*
      @name ae
      @description  Converts a given string in a sequence of the original
                      input and the HTML entity
      @param String string  String to convert
      */
    function ae(string){
        var all_chars_lowercase = string.toLowerCase();
        if(ents[string]) return ents[string];
        var all_chars_uppercase = string.toUpperCase();
        var RE_res = "";
        for(var i=0; i<string.length; i++){
            var char_lowercase = all_chars_lowercase.charAt(i);
            if(charMap[char_lowercase]){
                RE_res += charMap[char_lowercase];
                continue;
            }
            var char_uppercase = all_chars_uppercase.charAt(i);
            var RE_sub = [char_lowercase];
            RE_sub.push("&#0*" + char_lowercase.charCodeAt(0) + entityEnd);
            RE_sub.push("&#x0*" + char_lowercase.charCodeAt(0).toString(16) + entityEnd);
            if(char_lowercase != char_uppercase){
                /* Note: RE ignorecase flag has already been activated */
                RE_sub.push("&#0*" + char_uppercase.charCodeAt(0) + entityEnd);   
                RE_sub.push("&#x0*" + char_uppercase.charCodeAt(0).toString(16) + entityEnd);
            }
            RE_sub = "(?:" + RE_sub.join("|") + ")";
            RE_res += (charMap[char_lowercase] = RE_sub);
        }
        return(ents[string] = RE_res);
    }

    /*
      @name by
      @description  2nd argument for replace().
      */
    function by(match, group1, group2, group3){
        /* Note that this function can also be used to remove links:
         * return group1 + "javascript://" + group3; */
        return group1 + rel_to_abs(group2) + group3;
    }
    /*
      @name by2
      @description  2nd argument for replace(). Parses relevant HTML entities
      */
    var slashRE = new RegExp(ae("/"), 'g');
    var dotRE = new RegExp(ae("."), 'g');
    function by2(match, group1, group2, group3){
        /*Note that this function can also be used to remove links:
         * return group1 + "javascript://" + group3; */
        group2 = group2.replace(slashRE, "/").replace(dotRE, ".");
        return group1 + rel_to_abs(group2) + group3;
    }
    /*
      @name cr
      @description            Selects a HTML element and performs a
                                search-and-replace on attributes
      @param String selector  HTML substring to match
      @param String attribute RegExp-escaped; HTML element attribute to match
      @param String marker    Optional RegExp-escaped; marks the prefix
      @param String delimiter Optional RegExp escaped; non-quote delimiters
      @param String end       Optional RegExp-escaped; forces the match to end
                              before an occurence of <end>
     */
    function cr(selector, attribute, marker, delimiter, end){
        if(typeof selector == "string") selector = new RegExp(selector, "gi");
        attribute = att + attribute;
        marker = typeof marker == "string" ? marker : "\\s*=\\s*";
        delimiter = typeof delimiter == "string" ? delimiter : "";
        end = typeof end == "string" ? "?)("+end : ")(";
        var re1 = new RegExp('('+attribute+marker+'")([^"'+delimiter+']+'+end+')', 'gi');
        var re2 = new RegExp("("+attribute+marker+"')([^'"+delimiter+"]+"+end+")", 'gi');
        var re3 = new RegExp('('+attribute+marker+')([^"\'][^\\s>'+delimiter+']*'+end+')', 'gi');
        html = html.replace(selector, function(match){
            return match.replace(re1, by).replace(re2, by).replace(re3, by);
        });
    }
    /* 
      @name cri
      @description            Selects an attribute of a HTML element, and
                                performs a search-and-replace on certain values
      @param String selector  HTML element to match
      @param String attribute RegExp-escaped; HTML element attribute to match
      @param String front     RegExp-escaped; attribute value, prefix to match
      @param String flags     Optional RegExp flags, default "gi"
      @param String delimiter Optional RegExp-escaped; non-quote delimiters
      @param String end       Optional RegExp-escaped; forces the match to end
                                before an occurence of <end>
     */
    function cri(selector, attribute, front, flags, delimiter, end){
        if(typeof selector == "string") selector = new RegExp(selector, "gi");
        attribute = att + attribute;
        flags = typeof flags == "string" ? flags : "gi";
        var re1 = new RegExp('('+attribute+'\\s*=\\s*")([^"]*)', 'gi');
        var re2 = new RegExp("("+attribute+"\\s*=\\s*')([^']+)", 'gi');
        var at1 = new RegExp('('+front+')([^"]+)(")', flags);
        var at2 = new RegExp("("+front+")([^']+)(')", flags);
        if(typeof delimiter == "string"){
            end = typeof end == "string" ? end : "";
            var at3 = new RegExp("("+front+")([^\"'][^"+delimiter+"]*" + (end?"?)("+end+")":")()"), flags);
            var handleAttr = function(match, g1, g2){return g1+g2.replace(at1, by2).replace(at2, by2).replace(at3, by2)};
        } else {
            var handleAttr = function(match, g1, g2){return g1+g2.replace(at1, by2).replace(at2, by2)};
    }
        html = html.replace(selector, function(match){
             return match.replace(re1, handleAttr).replace(re2, handleAttr);
        });
    }

    /* <meta http-equiv=refresh content="  ; url= " > */
    cri("<meta"+any+att+"http-equiv\\s*=\\s*(?:\""+ae("refresh")+"\""+any+">|'"+ae("refresh")+"'"+any+">|"+ae("refresh")+"(?:"+ae(" ")+any+">|>))", "content", ae("url")+s+ae("=")+s, "i");

    cr("<"+any+att+"href\\s*="+any+">", "href"); /* Linked elements */
    cr("<"+any+att+"src\\s*="+any+">", "src"); /* Embedded elements */

    cr("<object"+any+att+"data\\s*="+any+">", "data"); /* <object data= > */
    cr("<applet"+any+att+"codebase\\s*="+any+">", "codebase"); /* <applet codebase= > */

    /* <param name=movie value= >*/
    cr("<param"+any+att+"name\\s*=\\s*(?:\""+ae("movie")+"\""+any+">|'"+ae("movie")+"'"+any+">|"+ae("movie")+"(?:"+ae(" ")+any+">|>))", "value");

    cr(/<style[^>]*>(?:[^"']*(?:"[^"]*"|'[^']*'))*?[^'"]*(?:<\/style|$)/gi, "url", "\\s*\\(\\s*", "", "\\s*\\)"); /* <style> */
    cri("<"+any+att+"style\\s*="+any+">", "style", ae("url")+s+ae("(")+s, 0, s+ae(")"), ae(")")); /*< style=" url(...) " > */
    return html;
}
function getIframeContent() {
    var frames = document.getElementsByTagName("iframe");

    var frameContent = [];  //итоговый контент iframe для экспорта
    let change_elem = [];// массив с элементами, которые будут меняться
    let new_elem = []; // массив с элементами, на которые будет проведена замена
    var innerHTML1; //редактируемый контент iframe
    // подготовка iframe для экспорта
    for(let i=0; i<frames.length; i++){
        
        let params=["datasets","qbPanel","button","filterLoad","filtermeasure"]; //id элементов, которые надо полностью убрать
        for (let j=0; j<params.length;j++){
            change_elem.push(frames[i].contentWindow.document.getElementById(params[j]).outerHTML); //поиск HTML кода по id тэга
            new_elem.push(" "); //значение, на которое будет заменено
        }
        let selected = []; //массив для id элементов, у которых есть select
        let x1 = frames[i].contentWindow.document.getElementsByClassName("filter"); //поиск элементов фильтра
        for (let j=0;j<x1.length;j++){
            selected.push(x1[j].id); //добавление id фильтров
        }
        selected.push("selectRow","selectColumn");
        for (let j=0; j<selected.length;j++){
            change_elem.push(frames[i].contentWindow.document.getElementById(selected[j]).outerHTML); //добавление html для элементов select
            let measurement =  frames[i].contentWindow.document.getElementById(selected[j]); //поиск самих элментов select
            let selectedOption = measurement.options[measurement.selectedIndex].text; //получение выбранного значения из select
            new_elem.push(selectedOption); //замена
        }
        selected=[];
        innerHTML1 = frames[i].contentWindow.document.body.innerHTML; // исходный HTML

        for(let j=0; j<change_elem.length; j++){
            innerHTML1 = innerHTML1.replace(change_elem[j],new_elem[j]); //замена элементов на необходимые
        }
        for (let j=0; j<frames[i].contentWindow.document.getElementsByTagName("caption").length;j++){
            innerHTML1=innerHTML1.replace(frames[i].contentWindow.document.getElementsByTagName("caption")[j].outerHTML,"");
        }
        innerHTML1= innerHTML1.replaceAll('<form>','');
        innerHTML1=innerHTML1.replaceAll('</form>','');
        //innerHTML1= innerHTML1.replace("Повернуть таблицу", " ");
        change_elem=[]; //очистка массива
        new_elem=[]; //очистка массива
        frameContent.push(innerHTML1); //добавление подготовленного iframe 
    }
    return frameContent;
 }
//подготовка html к экспорту
function preparehtml(element){
    var iframe = getIframeContent();
    let iframes = document.getElementsByTagName("iframe");
    let postURLHTML = replace_all_rel_by_abs(document.getElementById(element).innerHTML);
    //настройка отступов, при dd теге добавляются отступы
    postURLHTML=postURLHTML.replace("<dd>","<p>");
    postURLHTML=postURLHTML.replace("</dd>","</p>");
    // if (document.getElementsByTagName("dd").length != 0){
    //     let dd1 = document.createElement("p");
    //     dd1.innerHTML=document.getElementsByTagName("dd")[0].innerHTML;
    //     postURLHTML=postURLHTML.replace(replace_all_rel_by_abs(document.getElementsByTagName("dd")[0].outerHTML),replace_all_rel_by_abs(dd1.outerHTML));
    // }    
    let doc = document.getElementById(element);
    let fonts=doc.getElementsByTagName('*'); // все элементы страницы
    
    

    //удаление width у таблиц
    let tables = document.getElementsByTagName('table');
    for (let i=0;i<tables.length;i++){
        if (tables[i].outerHTML.includes('width')){
            let t = replace_all_rel_by_abs(tables[i].outerHTML);
            t = t.replaceAll('width','');
            console.log(tables[i].outerHTML);
            console.log(t);
            postURLHTML=postURLHTML.replace(tables[i].outerHTML,t);
        }
    }

    //цикл для удаления скрытых элементов и выравнивания шрифтов
    for (let i=0;i<fonts.length;i++){
        let old_tag = fonts[i].outerHTML;
        let old_font = fonts[i].style.fontSize;
        let old_style = fonts[i].getAttribute('style');
        //удаление скрытых элементов
        if(old_style != null){
            if (old_style.includes('display:none;')){
                
                if (postURLHTML.includes(old_tag)){
                    if (postURLHTML.includes(fonts[i-1].outerHTML)){ //исправить, надо сделать так, чтобы дочерный span не проходил условие
                postURLHTML=postURLHTML.replace(replace_all_rel_by_abs(old_tag),"");
                    }
                }
            }
        }
        //настройка шрифтов в документе
        if(old_font != ""){
        fonts[i].style.fontSize="12pt";
        postURLHTML=postURLHTML.replace(replace_all_rel_by_abs(old_tag),fonts[i].outerHTML);
        fonts[i].style.fontSize=old_font;
        }
        if (old_style == null){
            fonts[i].removeAttribute('style');
        }
    }
    //шрифты для облака тегов
    if (document.getElementsByClassName("tagCloud").length != 0){
        let tags = document.getElementsByClassName("tagCloud")[0].children;
        let tag = document.createElement('div');
        tag.className="tagCloud";
        for (let i=0; i<tags.length;i++){
            let e=document.createElement('a');
            e=tags[i].children[0].cloneNode(true);
            e.setAttribute("class",tags[i].className);
            tag.appendChild(e);
            tag.append('  ');
        }
        postURLHTML=postURLHTML.replace(replace_all_rel_by_abs(document.getElementsByClassName("tagCloud")[0].outerHTML),replace_all_rel_by_abs(tag.outerHTML));
    }
    //очистка от функциональных элементов редактирования
    if (document.getElementsByClassName("edit_section").length != 0){
        for (let i=0; i<document.getElementsByClassName("edit_section").length;i++){
            postURLHTML = postURLHTML.replace(replace_all_rel_by_abs(document.getElementsByClassName("edit_section")[i].outerHTML),"");
        }
    }
    //очистка html от функций javascript onclick
    if (document.getElementsByTagName("a").length !=0){
        let a_tags = document.getElementsByTagName("a");
        for (let i=0; i<a_tags.length;i++){
            if (a_tags[i].hasAttribute('onclick')){
                let cur_onclick=a_tags[i].outerHTML;
                let href = a_tags[i].getAttribute('href');
                let onclick=a_tags[i].getAttribute('onclick');
                a_tags[i].removeAttribute('onclick');
                a_tags[i].removeAttribute('href');
                postURLHTML = postURLHTML.replace(cur_onclick,a_tags[i].outerHTML);
                a_tags[i].setAttribute('href',href);
                a_tags[i].setAttribute('onclick',onclick);
            }
        }
    }
   //применение display:none; для дочерних тегов(при экспорте параметр не применяется на дочерние теги)
    // if (document.querySelectorAll('[style="display:none;"]').length !=0){
    //     for (let i=0; i<document.querySelectorAll('[style="display:none;"]').length;i++){
    //         let child=document.querySelectorAll('[style="display:none;"]')[i].children;
    //         for (let j=0; j<document.querySelectorAll('[style="display:none;"]')[i].childElementCount;j++){
    //             let disp = child[j].getAttribute('style');
    //             let elem = child[j].outerHTML;
    //             child[j].setAttribute('style','display:none;');
    //             postURLHTML=postURLHTML.replace(elem,child[j]);
    //             if (disp == null){
    //                 child[j].removeAttribute('style');
    //             }
    //             else{
    //             child[j].setAttribute('style',disp);
    //             }
    //         }
    //     }
    // }
   //выравнивание шрифтов
    //очистка html от функциональных элементов (кнопок)
    if (document.getElementById("AjaxJsonTarget") != null){
        //на странице может быть несколько кнопок, необходимо найти все
        let AjaxElements = document.querySelectorAll('[id="AjaxJsonTarget"]');
        AjaxElements.forEach((element) =>{
            postURLHTML=postURLHTML.replace(element.outerHTML,"");
            
        })
        
    } 
    if (iframes.length>0){
        for (let i=0;i<iframes.length;i++){
            postURLHTML=postURLHTML.replace(replace_all_rel_by_abs(iframes[i].outerHTML),iframe[i]);
        }
    }
    return postURLHTML;
}
//фукнция Экспорта в DOC
export function Export2Doc(element,orient, title=document.title){
    if (!window.Blob) {
       alert('Your legacy browser does not support this action.');
       return;
    }
 
    var blob, url, css;
  // landscape parameters
    var landscape = '@page row{size: 841.95pt 595.35pt;margin: 1cm 1cm 1cm 1cm;mso-page-orientation: landscape;mso-hyphenate: auto;mso-table-layout-alt: fixed;mso-linked-frame: linked;mso-ansi-font-size: 12pt;mso-list:none;}'; //отличие
    let portrait='@page row{size: 595.45pt 841.7pt;margin: 1.27cm 1.27cm 1.27cm 1.27cm;mso-page-orientation: portrait;mso-hyphenate: auto;mso-table-layout-alt: fixed;mso-linked-frame: linked;mso-ansi-font-size: 12pt;mso-list:none;}'; //отличие
    let prestyles = 'div.land {page: row; font-size:12pt;}'+
    'table.mytable {width: 100%;table-layout: fixed;border: 1px solid;border-collapse: collapse; font-size: 10pt;}'+ //parameters for Annotation Table
    'table.mytable td{vertical-align: top;}'+
    'table.mytable1 {width: 100%;table-layout: fixed;border: 1px solid;border-collapse: collapse; font-size: 7pt;}'+ //parameters for Glossary Table
    'table.mytable1 td{vertical-align: top;}'+
    'table.tbrowser {width:100%;border: 1px solid;border-collapse: collapse; text-align: right; font-size:10pt;}'+ //параметры для olap таблицы iframe
    'table.tbrowser tbody th{text-align: left;}'+
    'table.tbrowser tr,th, td {border: 1px solid; border-collapse: collapse;}'+
    'table.elementstable {font-size: 10pt;}';
    var preHtml = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><body>"; //отличие
    var postHtml = "</body></html>";
    var preland = '<div class="land">'; //для применения стилей
    let doc = document.getElementById(element);
    //шрифты для облака тегов
    let tagCloudStyle=".tagCloud{text-align: justify;}";
    if (document.getElementsByClassName("tagCloud").length != 0){
        let tags = document.getElementsByClassName("tagCloud")[0].children;
       
        for (let i=0; i<tags.length;i++){
            if(!tagCloudStyle.includes(tags[i].className)){
            tagCloudStyle+="."+tags[i].className+"{"+"font-size:"+window.getComputedStyle(tags[i],null).getPropertyValue("font-size")+";}";
            }   
        }
    }
    //postURLHTML= replace_all_rel_by_abs(postURLHTML);
    let postURLHTML=preparehtml(element);
    //формирование html для экспорта
    if (orient == "1"){ //checking for orientation
        css = '<style>'+landscape+prestyles+tagCloudStyle+'</style>';
    }
    else{
        css='<style>'+portrait+prestyles+tagCloudStyle+'</style>';
    }
    //var html = preHtml+css+preland+document.getElementById("document-title").innerHTML+postURLHTML+"</div>"+postHtml;
    //TODO: Заменить заголовок <h1>TITLE 1</h1>
    var html = preHtml+css+preland+"<h1>"+title+"</h1>"+postURLHTML+"</div>"+postHtml;
    blob = new Blob(['\ufeff', css + html], {
      type: 'application/msword'
    });

   if (postURLHTML.includes('<img')){
    //  _html_ will be replace with custom html
    var meta= "Mime-Version: 1.0\nContent-Base: " + location.href + "\nContent-Type: Multipart/related; boundary=\"NEXT.ITEM-BOUNDARY\";type=\"text/html\"\n\n--NEXT.ITEM-BOUNDARY\nContent-Type: text/html; charset=\"utf-8\"\nContent-Location: " + location.href + "\n\n<!DOCTYPE html>\n<html>\n_html_</html>";
    //  _styles_ will be replaced with custome css
    var head= "<head>\n<meta http-equiv=\"Content-Type\" content=\"text/html; charset=utf-8\">\n<style>\n_styles_\n</style>\n</head>\n";
    var options = { maxWidth: 624};
    var images = Array();
    var img=doc.querySelectorAll('img');
    for (var i = 0; i < img.length; i++) {
        // Calculate dimensions of output image
        var w = Math.min(img[i].width, options.maxWidth);
        var h = img[i].height * (w / img[i].width);
        // Create canvas for converting image to data URL
        var canvas = document.createElement("CANVAS");
        canvas.width = w;
        canvas.height = h;
        // Draw image to canvas
        var context = canvas.getContext('2d');
        context.drawImage(img[i], 0, 0, w, h);
        // Get data URL encoding of image
        var uri = canvas.toDataURL("image/png");
        
        img[i].setAttribute("src",img[i].src);
        img[i].width = w;
        img[i].height = h;
        // Save encoded image to array
        images[i] = {
            type: uri.substring(uri.indexOf(":") + 1, uri.indexOf(";")),
            encoding: uri.substring(uri.indexOf(";") + 1, uri.indexOf(",")),
            location: img[i].getAttribute("src"),
            data: uri.substring(uri.indexOf(",") + 1)
        };
    }

    // Prepare bottom of mhtml file with image data
    var imgMetaData = "\n";
    for (var i = 0; i < images.length; i++) {
        imgMetaData += "--NEXT.ITEM-BOUNDARY\n";
        imgMetaData += "Content-Location: " + images[i].location + "\n";
        imgMetaData += "Content-Type: " + images[i].type + "\n";
        imgMetaData += "Content-Transfer-Encoding: " + images[i].encoding + "\n\n";
        imgMetaData += images[i].data + "\n\n";
        
    }
    imgMetaData += "--NEXT.ITEM-BOUNDARY--";
// end Image Area %%

     var output = meta.replace("_html_", head.replace("_styles_", css) +  html) + imgMetaData;

    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(output);
    }
    else{
     var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    }
    //
     // Specify link url
   
    //let filename=document.getElementById("document-title").textContent;
    //TODO: Заменить "filename" на заголовок
    let filename="filename";
    filename=filename.replaceAll('"',"''");//подготовка названия файла, кавычки менялись на нижнее подчеркивание
     // Specify file name
    filename = filename?filename+'.doc':'document.doc';
     
     
     // Create download link element
     var downloadLink = document.createElement("a");
     document.body.appendChild(downloadLink);
     
     if(navigator.msSaveOrOpenBlob ){
         navigator.msSaveOrOpenBlob(blob, filename);
     }else{
         // Create a link to the file
         downloadLink.href = url;
         
         // Setting the file name
         downloadLink.download = filename;
         
         //triggering the function
         downloadLink.click();
     }
     
     document.body.removeChild(downloadLink);
  };

  export function Export2PDF(element,orient, title=document.title){
    var css;
  // landscape parameters
    var landscape = '@page row{size: 841.95pt 595.35pt;margin: 1cm 1cm 1cm 1cm;}';
    let portrait='@page row{size: 595.35pt 841.95pt;margin: 1.27cm 1.27cm 1.27cm 1.27cm; }';
    let prestyles = 'div.land { page:row;font-size:12pt;font-family: "Times New Roman", serif;}'+
    'table.mytable {width: 100%;table-layout: fixed;border: 1px solid;border-collapse: collapse; font-size: 10pt;}'+ //parameters for Annotation Table
    'table.mytable td{vertical-align: top;}'+
    'table.mytable1 {width: 100%;table-layout: fixed;border: 1px solid;border-collapse: collapse; font-size: 8pt;}'+ //parameters for Glossary Table
    'table.mytable1 td{vertical-align: top;}'+
    'table.tbrowser {width:100%;border: 1px solid;border-collapse: collapse; text-align: right; font-size:10pt;}'+ //параметры для olap таблицы iframe
    'table.tbrowser tbody th{text-align: left;}'+
    'table.tbrowser tr,th, td {border: 1px solid; border-collapse: collapse;}'+
    'table.elementstable {font-size: 10pt;}';
    var preHtml = "<html><head></head><body>";
    var postHtml = "</body></html>";
    var preland = '<div class="land">'; //для применения стилей

    //шрифты для облака тегов
    let tagCloudStyle=".tagCloud{text-align: justify;}";
    if (document.getElementsByClassName("tagCloud").length != 0){
        let tags = document.getElementsByClassName("tagCloud")[0].children;
       
        for (let i=0; i<tags.length;i++){
            if(!tagCloudStyle.includes(tags[i].className)){
            tagCloudStyle+="."+tags[i].className+"{"+"font-size:"+window.getComputedStyle(tags[i],null).getPropertyValue("font-size")+";}";
            }   
        }
    }
   
    let postURLHTML=preparehtml(element);
    //формирование html для экспорта
    if (orient == "1"){ //checking for orientation
        css = '<style>'+landscape+prestyles+tagCloudStyle+'</style>';
    }
    else{
        css='<style>'+portrait+prestyles+tagCloudStyle+'</style>';
    }
    //var html = preHtml+css+preland+document.getElementById("document-title").innerHTML+postURLHTML+"</div>"+postHtml;
    //TODO: Заменить заголовок <h1>TITLE 2</h1>
    var html = preHtml+css+preland+"<h1>"+title+"</h1>"+postURLHTML+"</div>"+postHtml;
    printDiv(html);

    
  };
  function printDiv(html) {
    // let mywindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');
    // mywindow.document.write(html);
    // mywindow.document.close(); // necessary for IE >= 10
    // mywindow.focus(); // necessary for IE >= 10*/
  
    // mywindow.print();
    // mywindow.close();
    var frame1 = document.createElement('iframe');
            frame1.name = "frame3";
            frame1.style.position = "absolute";
            frame1.style.top = "-1000000px";
            document.body.appendChild(frame1);
            var mywindow = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument.documentElement ? frame1.contentDocument.documentElement : frame1.contentDocument;
            mywindow.document.open();
            mywindow.document.write(html);
            // mywindow.document.write('</head><body>');
            // mywindow.document.write(data);
            // mywindow.document.write('</body></html>');
            mywindow.document.close(); // necessary for IE >= 10
            setTimeout(function () {
                window.frames["frame3"].focus(); // necessary for IE >= 10
                window.frames["frame3"].print(); // necessary for IE >= 10
            }, 500);
            setTimeout(function () {
               document.body.removeChild(frame1);
            }, 2000);
   //return true;
  };